import Svg from '../Svg/Svg'

const LoadMore = (props) => {
  const { modifier, label, onClick } = props

  let styles = ``
  if(modifier) {
    styles = ` ${modifier}`;
  }

  return (
    <div className={`LoadMore${styles}`}>
      <div className={`LoadMore-inner`}>
        <div className={`LoadMore-button`} onClick={() => onClick()}>
          <span className={`LoadMore-buttonLabel`}>{label || `Load more`}</span><Svg id="icon-plus" modifier="LoadMore-svg"/>
        </div>
      </div>
    </div>
  )
}

export default LoadMore
